module.exports = "---\ntitle: \"采石\"\ntime: \"2024-08-22\"\n---\n\n迷幻摇滚，前卫摇滚，加点爵士，还得是结尾的键盘最吸引我，现代化爆破扬起尘土，轰隆淹没单薄的鼓点，键盘和小号又冲破纷纷落下的碎屑，是有《山雀》。\n";